import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { usePlansDataStore } from '@store/plansStore';
import { useQuoteStore, useSelectedQuoteStore } from '@store/QuoteStore';

export const BrandTablet = () => {
  const { selectedPlan } = usePlansDataStore();
  const { selectedQuote } = useSelectedQuoteStore();
  const [totalPayment, setTotalPayment] = useState<string>('');
  let position = 0
  
  if(selectedQuote.package === "AMP"){
    position = 0
  }
  if(selectedQuote.package === "LIMIT"){
    position = 1
  }
  if(selectedQuote.package === "RC"){
    position = 2
  }
  useEffect(() => {
    let totalNumber = 0;
    selectedQuote.available_packages[position].receipts.map((item: any) => {
      const number = Number(item?.total_premium);
      totalNumber += number;
    });
    setTotalPayment(totalNumber.toString());
  }, []);
  return (
    <Box
      borderRadius={2}
      marginTop={2}
      display={'flex'}
      flexDirection={'column'}
      alignItems={'center'}
      padding={2}
      style={{ backgroundColor: '#ffffff' }}
    >
      <Box
        component={'img'}
        src={selectedQuote.company_logo}
        sx={{
          width: 157,
        }}
        alt={selectedQuote.company_logo}
        style={{ objectFit: 'contain' }}
      />
      <Box
        width={'90%'}
        borderRadius={2}
        marginTop={2}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        padding={1}
        style={{ backgroundColor: '#ffffff' }}
      >
        <Typography color="#212121" fontSize={13}>
          Total a pagar
        </Typography>
        <Typography style={{ fontWeight: 'bold' }} fontSize={28}>
          $
          {parseFloat(
            parseFloat(totalPayment).toFixed(2)
          ).toLocaleString('es-MX', { minimumFractionDigits: 2 })}
        </Typography>
        <Typography fontSize={14} style={{ color: '#8F8F8F' }}>
          Costo anual
        </Typography>
      </Box>
    </Box>
  );
};
